import axios from 'axios'
// import router from '../routerManuaConfig'
import router from '../router/index'
import store from '../store'
import Vue from 'vue'

import applicationUserManager from '../Auth/applicationusermanager'

let base = ''
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
// let base = process.env.NODE_ENV=="production"? 'http://localhost:8081':'';

// 请求延时
axios.defaults.timeout = 20000

var storeTemp = store
axios.interceptors.request.use(
  (config) => {
    var curTime = new Date()
    var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))

    if (
      storeTemp.state.token &&
      curTime < expiretime &&
      storeTemp.state.tokenExpire
    ) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = 'Bearer ' + storeTemp.state.token
    }

    saveRefreshtime()

    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    let errInfo = { success: false, message: '错误' }
    // 超时请求处理
    var originalRequest = error.config
    if (
      error.code == 'ECONNABORTED' &&
      error.message.indexOf('timeout') != -1 &&
      !originalRequest._retry
    ) {
      errInfo.message = '请求超时！'
      originalRequest._retry = true
    } else if (error.response) {
      if (error.response.status == 401) {
        var curTime = new Date()
        var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
        // 在用户操作的活跃期内
        if (window.localStorage.refreshtime && curTime <= refreshtime) {
          return refreshToken({ token: window.localStorage.Token }).then(
            (res) => {
              if (res.success) {
                Vue.prototype.$message({
                  message: 'refreshToken success! loading data...',
                  type: 'success',
                })

                store.commit('saveToken', res.response.token)

                var curTime = new Date()
                var expiredate = new Date(
                  curTime.setSeconds(
                    curTime.getSeconds() + res.response.expires_in
                  )
                )
                store.commit('saveTokenExpire', expiredate)

                error.config.__isRetryRequest = true
                error.config.headers.Authorization =
                  'Bearer ' + res.response.token
                return axios(error.config)
              } else {
                // 刷新token失败 清除token信息并跳转到登录页面
                ToLogin()
              }
            }
          )
        } else {
          // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
          ToLogin()
        }
      }
      // 403 无权限
      else if (error.response.status == 403) {
        errInfo.message = '失败！该操作无权限'
      }
      // 429 ip限流
      else if (error.response.status == 429) {
        errInfo.message = '刷新次数过多，请稍事休息重试！'
      } else if (error.response.status == 404) {
        // 404 不存在
        errInfo.message = '失败！访问接口不存在'
      } else if (error.response.status == 500) {
        // 500 服务器异常
        errInfo.message = '失败！服务器异常'
      } else if (error.response.status == 405) {
        // 405 请求http方法错误
        errInfo.message = '失败！请求http方法错误'
      } else if (error.response.status == 415) {
        // 415 参数没有指定Body还是Query
        errInfo.message = '失败！参数没有指定Body还是Query'
      } else {
        //其他错误参数
        errInfo.message = '失败！请求错误' + error.response.status
      }
    } else {
      errInfo.message = '失败！服务器断开'
    }
    Vue.prototype.$message({
      message: errInfo.message,
      type: 'error',
    })
    return errInfo // 返回接口返回的错误信息
  }
)

export const BaseApiUrl = base

// 登录
export const requestLogin = (params) => {
  return axios
    .get(`${base}/api/login/jwttoken3.0`, { params: params })
    .then((res) => res.data)
}
export const requestLoginMock = (params) => {
  return axios.post(`${base}/login`, params).then((res) => res.data)
}

export const refreshToken = (params) => {
  return axios
    .get(`${base}/api/login/RefreshToken`, { params: params })
    .then((res) => res.data)
}

export const saveRefreshtime = (params) => {
  let nowtime = new Date()
  let lastRefreshtime = window.localStorage.refreshtime
    ? new Date(window.localStorage.refreshtime)
    : new Date(-1)
  let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

  let refreshCount = 1 //滑动系数
  if (lastRefreshtime >= nowtime) {
    lastRefreshtime = nowtime > expiretime ? nowtime : expiretime
    lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount)
    window.localStorage.refreshtime = lastRefreshtime
  } else {
    window.localStorage.refreshtime = new Date(-1)
  }
}
const ToLogin = (params) => {
  store.commit('saveToken', '')
  store.commit('saveTokenExpire', '')
  store.commit('saveTagsData', '')
  window.localStorage.removeItem('user')
  window.localStorage.removeItem('NavigationBar')

  if (global.IS_IDS4) {
    applicationUserManager.login()
  } else {
    router.replace({
      path: '/login',
      query: { redirect: router.currentRoute.fullPath },
    })
    //window.location.reload()
  }
}

export const getUserByToken = (params) => {
  return axios
    .get(`${base}/api/user/getInfoByToken`, { params: params })
    .then((res) => res.data)
}

export function testapi2() {
  console.log('api is ok.')
}

export const testapi = (pa) => {
  console.log('api is ok.')
}

// 用户管理
export const getUserListPage = (params) => {
  return axios.get(`${base}/api/user/get`, { params: params })
}
export const removeUser = (params) => {
  return axios.delete(`${base}/api/user/delete`, { params: params })
}
export const editUser = (params) => {
  return axios.put(`${base}/api/user/put`, params)
}
export const addUser = (params) => {
  return axios.post(`${base}/api/user/post`, params)
}
export const batchRemoveUser = (params) => {
  return axios.delete(`${base}/api/Claims/BatchDelete`, { params: params }) //没做
}

// 角色管理
export const getRoleListPage = (params) => {
  return axios.get(`${base}/api/role/get`, { params: params })
}
export const removeRole = (params) => {
  return axios.delete(`${base}/api/role/delete`, { params: params })
}
export const editRole = (params) => {
  return axios.put(`${base}/api/role/put`, params)
}
export const addRole = (params) => {
  return axios.post(`${base}/api/role/post`, params)
}

// 接口模块管理
export const getModuleListPage = (params) => {
  return axios.get(`${base}/api/module/get`, { params: params })
}
export const removeModule = (params) => {
  return axios.delete(`${base}/api/module/delete`, { params: params })
}
export const editModule = (params) => {
  return axios.put(`${base}/api/module/put`, params)
}
export const addModule = (params) => {
  return axios.post(`${base}/api/module/post`, params)
}

// 菜单模块管理
export const getPermissionListPage = (params) => {
  return axios.get(`${base}/api/permission/get`, { params: params })
}
export const getPermissionTreeTable = (params) => {
  return axios.get(`${base}/api/permission/GetTreeTable`, { params: params })
}
export const removePermission = (params) => {
  return axios.delete(`${base}/api/permission/delete`, { params: params })
}
export const editPermission = (params) => {
  return axios.put(`${base}/api/permission/put`, params)
}
export const addPermission = (params) => {
  return axios.post(`${base}/api/permission/post`, params)
}
export const getPermissionTree = (params) => {
  return axios.get(`${base}/api/permission/getpermissiontree`, {
    params: params,
  })
}
export const getPermissionIds = (params) => {
  return axios.get(`${base}/api/permission/GetPermissionIdByRoleId`, {
    params: params,
  })
}

export const addRolePermission = (params) => {
  return axios.post(`${base}/api/permission/Assign`, params)
}
export const getNavigationBar = (params) => {
  return axios
    .get(`${base}/api/permission/GetNavigationBar`, { params: params })
    .then((res) => res.data)
}

// Bug模块管理
export const getBugListPage = (params) => {
  return axios.get(`${base}/api/TopicDetail/get`, { params: params })
}
export const removeBug = (params) => {
  return axios.delete(`${base}/api/TopicDetail/delete`, { params: params })
}
export const editBug = (params) => {
  return axios.put(`${base}/api/TopicDetail/update`, params)
}
export const addBug = (params) => {
  return axios.post(`${base}/api/TopicDetail/post`, params)
}

// 博客模块管理
export const getBlogListPage = (params) => {
  return axios.get(`${base}/api/Blog`, { params: params })
}
export const getBlogDeatil = (params) => {
  return axios.get(`${base}/api/Blog/DetailNuxtNoPer`, { params: params })
}
export const editBlog = (params) => {
  return axios.put(`${base}/api/Blog/update`, params)
}
export const removeBlog = (params) => {
  return axios.delete(`${base}/api/Blog/delete`, { params: params })
}

const diagnosticsHttp = axios.create({ timeout: 15000 })
function diagnosticRequest(action, method, data, token, params) {
  const jwt = window.localStorage.Token || store.state.token
  const headers = { Authorization: 'Bearer ' + (jwt || '') }
  if (token) headers['X-Diagnostics-Token'] = token
  return diagnosticsHttp.request({ url: `${base}/api/ClientDiagnostics/${action}`, baseURL: axios.defaults.baseURL, method, data, params, headers }).then(res => {
    if (!res.data || !res.data.success) {
      const error = new Error((res.data && res.data.msg) || '诊断请求失败')
      error.status = res.data && res.data.status
      throw error
    }
    return res.data
  }).catch(cause => {
    const status = (cause.response && cause.response.status) || cause.status || 0
    const message = (cause.response && cause.response.data && cause.response.data.msg) || cause.message || '诊断请求失败'
    if (cause.config) cause.config.data = null
    const error = new Error(message)
    error.status = status
    throw error
  })
}
export const getClientDiagnosticsMeta = () => diagnosticRequest('Meta', 'get')
export const unlockClientDiagnostics = password => diagnosticRequest('Unlock', 'post', { password })
export const getClientDiagnostics = (params, token) => diagnosticRequest('List', 'get', null, token, params)
export const getClientDiagnosticDetail = (id, token) => diagnosticRequest('Detail', 'get', null, token, { id })
export const getClientDiagnosticsStorage = token => diagnosticRequest('Storage', 'get', null, token)
export const cleanupClientDiagnostics = (mode, token) => diagnosticRequest('Cleanup', 'post', {
  mode, confirm: mode === 'all' ? 'CLEAR_CLIENT_DIAGNOSTICS' : undefined
}, token)
export const lockClientDiagnostics = (token, jwt) => {
  if (!jwt) return diagnosticRequest('Lock', 'post', null, token)
  return diagnosticsHttp.post(`${base}/api/ClientDiagnostics/Lock`, null, { baseURL: axios.defaults.baseURL, headers: { Authorization: 'Bearer ' + jwt, 'X-Diagnostics-Token': token } }).then(res => res.data).catch(() => null)
}

// 日志
export const getLogs = (params) => {
  return axios.get(`${base}/api/Monitor/get`, { params: params })
}
export const getRequestApiinfoByWeek = (params) => {
  return axios.get(`${base}/api/Monitor/GetRequestApiinfoByWeek`, {
    params: params,
  })
}
export const getAccessApiByDate = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByDate`, {
    params: params,
  })
}
export const getAccessApiByHour = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByHour`, {
    params: params,
  })
}
export const getServerInfo = (params) => {
  return axios.get(`${base}/api/Monitor/Server`, { params: params })
}
export const getAccessLogs = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessLogs`, { params: params })
}
export const getIds4UsersGrow = (params) => {
  return axios.get(`${base}/api/Monitor/GetIds4Users`, { params: params })
}
export const getActiveUsers = (params) => {
  return axios.get(`${base}/api/Monitor/GetActiveUsers`, { params: params })
}

// Task管理
export const getTaskListPage = (params) => {
  return axios.get(`${base}/api/TasksQz/get`, { params: params })
}
export const removeTask = (params) => {
  return axios.delete(`${base}/api/TasksQz/delete`, { params: params })
}
export const editTask = (params) => {
  return axios.put(`${base}/api/TasksQz/put`, params)
}
export const addTask = (params) => {
  return axios.post(`${base}/api/TasksQz/post`, params)
}

export const startJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StartJob`, { params: params })
}
export const stopJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StopJob`, { params: params })
}
export const reCovery = (params) => {
  return axios.get(`${base}/api/TasksQz/ReCovery`, { params: params })
}
export const pauseJob = (params) => {
  return axios.get(`${base}/api/TasksQz/PauseJob`, { params: params })
}
export const resumeJob = (params) => {
  return axios.get(`${base}/api/TasksQz/ResumeJob`, { params: params })
}
export const getTaskNameSpace = (params) => {
  return axios.get(`${base}/api/TasksQz/GetTaskNameSpace`, { params: params })
}

// ids4
export const getAchieveUsers_IS4 = (params) => {
  return axios.get(`${base}/is4api/GetAchieveUsers`, { params: params })
}

//微信公众号
export const getWeChatAccount = (params) => {
  return axios.get(`${base}/api/WeChatConfig/get`, { params: params })
}
export const removeWeChatAccount = (params) => {
  return axios.delete(`${base}/api/WeChatConfig/delete`, { params: params })
}
export const batchDeleteChatAccount = (params) => {
  return axios.delete(`${base}/api/WeChatConfig/BatchDelete`, {
    params: params,
  })
}
export const addWeChatAccount = (params) => {
  return axios.post(`${base}/api/WeChatConfig/post`, params)
}
export const updateWeChatAccount = (params) => {
  return axios.put(`${base}/api/WeChatConfig/put`, params)
}
export const getWeChatTemplate = (params) => {
  return axios.get(`${base}/api/WeChat/GetTemplate`, { params: params }) //获取模板
}
export const refreshWeChatToken = (params) => {
  return axios.get(`${base}/api/WeChat/RefreshToken`, { params: params }) //更新Token
}
export const getWeChatMenu = (params) => {
  return axios.get(`${base}/api/WeChat/GetMenu`, { params: params }) //获取微信菜单
}
export const updateWeChatMenu = (params) => {
  return axios.put(`${base}/api/WeChat/updateMenu`, params) //更新微信菜单
}
export const getWeChatCompany = (params) => {
  return axios.get(`${base}/api/WeChatCompany/get`, { params: params })
}
export const removeWeChatCompany = (params) => {
  return axios.delete(`${base}/api/WeChatCompany/delete`, { params: params })
}
export const batchDeleteWeChatCompany = (params) => {
  return axios.delete(`${base}/api/WeChatCompany/BatchDelete`, {
    params: params,
  })
}
export const addWeWeChatCompany = (params) => {
  return axios.post(`${base}/api/WeChatCompany/post`, params)
}
export const updateWeChatCompany = (params) => {
  return axios.put(`${base}/api/WeChatCompany/put`, params)
}
export const getWeChatPushLog = (params) => {
  return axios.get(`${base}/api/WeChatPushLog/get`, { params: params })
}
export const getWeChatSubUser = (params) => {
  return axios.get(`${base}/api/WeChat/GetSubUsers`, { params: params })
}
export const getWeChatBindUser = (params) => {
  return axios.get(`${base}/api/WeChatSub/get`, { params: params })
}
export const pushTestMsg = (params) => {
  return axios.post(`${base}/api/WeChat/PushTxtMsg`, params)
}
export const pushCardMsg = (params) => {
  return axios.post(`${base}/api/WeChat/PushCardMsg`, params)
}

// 部门模块管理
export const getDepartmentListPage = (params) => {
  return axios.get(`${base}/api/department/get`, { params: params })
}
export const getDepartmentTreeTable = (params) => {
  return axios.get(`${base}/api/department/getTreeTable`, { params: params })
}

export const removeDepartment = (params) => {
  return axios.delete(`${base}/api/department/delete`, { params: params })
}
export const editDepartment = (params) => {
  return axios.put(`${base}/api/department/put`, params)
}
export const addDepartment = (params) => {
  return axios.post(`${base}/api/department/post`, params)
}
export const getDepartmentTree = (params) => {
  return axios.get(`${base}/api/department/getDepartmentTree`, {
    params: params,
  })
}

// 学员管理Member
export const MemberGetList = (params) => {
  return axios.post(`${base}/api/WebMember/GetList`, params)
}
export const MemberSaveAudit = (params) => {
  return axios.get(`${base}/api/WebMember/SaveAudit`, {
    params: params,
  })
}
export const MemberGet = (params) => {
  return axios.get(`${base}/api/WebMember/Get`, {
    params: params,
  })
}
export const GetMemberAllTag = (params) => {
  return axios.get(`${base}/api/WebMember/GetMemberAllTag`, {
    params: params,
  })
}
export const MemberTagPut = (params) => {
  return axios.put(`${base}/api/WebMember/Put`, params)
}
export const GiveMemberCertificate = (params) => {
  return axios.post(`${base}/api/WebMember/GiveMemberCertificate`, params)
}
// 证书管理Certificate
export const CertificateGetList = (params) => {
  return axios.get(`${base}/api/WebCertificate/GetList`, {
    params: params,
  })
}
export const CertificatePost = (params) => {
  return axios.post(`${base}/api/WebCertificate/Post`, params)
}
export const CertificatePut = (params) => {
  return axios.put(`${base}/api/WebCertificate/Put`, params)
}
export const CertificateGet = (params) => {
  return axios.get(`${base}/api/WebCertificate/Get`, {
    params: params,
  })
}

// 课程管理Curriculum
export const CurriculumList = (params) => {
  return axios.post(`${base}/api/WebCurriculum/GetList`, params)
}
export const GetMemberCultivateList = (params) => {
  return axios.post(`${base}/api/WebCurriculum/GetMemberCultivateList`, params)
}
export const ExportToExcelMemberCultivateList = (params) => {
  return axios.post(
    `${base}/api/WebCurriculum/ExportToExcelMemberCultivateList`,
    params
  )
}
export const ExportToExcelGetCurriculumReportList = (params) => {
  return axios.post(
    `${base}/api/WebCurriculum/ExportToExcelGetCurriculumReportList`,
    params
  )
}
export const ExportToExcelGetCustomReportList = (params) => {
  return axios.post(
    `${base}/api/WebCurriculum/ExportToExcelGetCustomReportList`,
    params
  )
}
export const ExportToExcelGetMemberReportList = (params) => {
  return axios.post(
    `${base}/api/WebCurriculum/ExportToExcelGetMemberReportList`,
    params
  )
}
export const GetCurriculumReportList = (params) => {
  return axios.post(`${base}/api/WebCurriculum/GetCurriculumReportList`, params)
}
export const GetCustomReportList = (params) => {
  return axios.post(`${base}/api/WebCurriculum/GetCustomReportList`, params)
}
export const GetMemberReportList = (params) => {
  return axios.post(`${base}/api/WebCurriculum/GetMemberReportList`, params)
}
export const CurriculumPost = (params) => {
  return axios.post(`${base}/api/WebCurriculum/AddCurricula`, params)
}
export const CurriculumPut = (params) => {
  return axios.put(`${base}/api/WebCurriculum/UptCurricula`, params)
}
export const CurriculumGet = (params) => {
  return axios.get(`${base}/api/WebCurriculum/Get`, {
    params: params,
  })
}
export const GetCurriculumGroupList = (params) => {
  return axios.post(`${base}/api/WebCurriculum/GetCurriculumGroupList`, params)
}
export const AddCurriculumGroup = (params) => {
  return axios.post(`${base}/api/WebCurriculum/AddCurriculumGroup`, params)
}
export const UptCurriculumGroup = (params) => {
  return axios.put(`${base}/api/WebCurriculum/UptCurriculumGroup`, params)
}
export const GetCurriculumGroup = (params) => {
  return axios.get(`${base}/api/WebCurriculum/GetCurriculumGroup`, {
    params: params,
  })
}
export const GetCurriculumGroupSelectList = (params) => {
  return axios.get(`${base}/api/WebCurriculum/GetCurriculumGroupSelectList`, {
    params: params,
  })
}
export const GetCurriculumGroupSecondarySelectList = (params) => {
  return axios.get(
    `${base}/api/WebCurriculum/GetCurriculumGroupSecondarySelectList`,
    {
      params: params,
    }
  )
}
export const QrCodeCurriculumGet = (params) => {
  return axios.get(`${base}/api/WebCurriculum/GetQrCodeUrl`, {
    params: params,
  })
}

// 视频Content-Type修复
export const ScanVideoContentType = () => {
  return axios.post(`${base}/api/WebCurriculum/ScanVideoContentType`, {}, { timeout: 120000 })
}
export const FixSingleVideoContentType = (params) => {
  return axios.get(`${base}/api/WebCurriculum/FixSingleVideoContentType`, {
    params: params,
  })
}
export const RollbackVideoContentType = (params) => {
  return axios.get(`${base}/api/WebCurriculum/RollbackVideoContentType`, {
    params: params,
  })
}

// export const QrCodeExaminationGet = (params) => {
//   return axios.get(`${base}/api/WebExamination/GetQrCodeUrl`, {
//     params: params,
//   });
// };
// 标签管理Tag
export const TagList = (params) => {
  return axios.get(`${base}/api/WebTag/GetList`, {
    params: params,
  })
}
export const TagPost = (params) => {
  return axios.post(`${base}/api/WebTag/Post`, params)
}
export const TagPut = (params) => {
  return axios.put(`${base}/api/WebTag/Put`, params)
}
export const TagGet = (params) => {
  return axios.get(`${base}/api/WebTag/Get`, {
    params: params,
  })
}
export const getTagListPage = (params) => {
  return axios.get(`${base}/api/WebTag/GetTagsList`, {
    params: params,
  })
}
export const getExamTagListPage = (params) => {
  return axios.get(`${base}/api/WebTag/GetExamTagList`, {
    params: params,
  })
}

// export const getCurriculumTagListPage = (params) => {
//   return axios.get(`${base}/api/WebTag/GetCurriculumTagList`, {
//     params: params,
//   });
// };

export const getAllTagListPage = (params) => {
  return axios.get(`${base}/api/WebTag/GetAllTagList`, {
    params: params,
  })
}

// 评论管理Evaluation
export const EvaluationList = (params) => {
  return axios.get(`${base}/api/WebEvaluation/GetList`, {
    params: params,
  })
}
export const EvaluationPost = (params) => {
  return axios.post(`${base}/api/WebEvaluation/Post`, params)
}
export const UptEvaluation = (params) => {
  return axios.get(`${base}/api/WebEvaluation/UptEvaluation`, {
    params: params,
  })
}

// 考试管理Examination
export const ExaminationList = (params) => {
  return axios.get(`${base}/api/WebExamination/GetList`, {
    params: params,
  })
}
export const GetTopicList = (params) => {
  return axios.post(`${base}/api/WebExamination/GetTopicList`, params)
}
export const GetMemberExamList = (params) => {
  return axios.post(`${base}/api/WebExamination/GetMemberExamList`, params)
}
export const ExportToExcelMemberExamList = (params) => {
  return axios.get(`${base}/api/WebExamination/ExportToExcelMemberExamList`, {
    params: params,
  })
}
export const GetMemberAnswerList = (params) => {
  return axios.get(`${base}/api/WebExamination/GetMemberAnswerList`, {
    params: params,
  })
}
export const ExaminationPost = (params) => {
  return axios.post(`${base}/api/WebExamination/Post`, params)
}
export const ExaminationPut = (params) => {
  return axios.put(`${base}/api/WebExamination/Put`, params)
}
export const ExaminationGet = (params) => {
  return axios.get(`${base}/api/WebExamination/Get`, {
    params: params,
  })
}
export const CertificateId_GetList = (params) => {
  return axios.get(`${base}/api/WebExamination/GetCertificateList`, {
    params: params,
  })
}
export const CurriculumId_GetList = (params) => {
  return axios.get(`${base}/api/WebExamination/GetCurriculumList`, {
    params: params,
  })
}
export const ClearTipic_Delete = (params) => {
  return axios.delete(`${base}/api/WebExamination/ClearTipic`, {
    params: params,
  })
}

export const IdentityId_GetList = (params) => {
  return axios.get(`${base}/api/WebIdentity/GetListDic`, {
    params: params,
  })
}
export const GiveMemberIdentity = (params) => {
  return axios.post(`${base}/api/WebMember/GiveMemberIdentity`, params)
}
export const GiveCurriculumIdentity = (params) => {
  return axios.post(`${base}/api/WebMember/GiveCurriculumIdentity`, params)
}
export const IdentityGetList = (params) => {
  return axios.get(`${base}/api/WebIdentity/GetList`, {
    params: params,
  })
}
export const IdentityPost = (params) => {
  return axios.post(`${base}/api/WebIdentity/Post`, params)
}
export const IdentityPut = (params) => {
  return axios.put(`${base}/api/WebIdentity/Put`, params)
}
export const IdentityGet = (params) => {
  return axios.get(`${base}/api/WebIdentity/Get`, {
    params: params,
  })
}

// 个人中心
export const UptUser = (params) => {
  return axios.post(`${base}/api/user/UptUser`, params)
}

// 修改学员信息
export const UpdatePut = (params) => {
  return axios.post(`${base}/api/WebMember/UpdatePut`, params)
}

// 地址
export const GetStoreAre = (params) => {
  return axios.post(`${base}/api/WeChatMember/GetStoreArea`, params)
}

// 获取零售商
export const GetStoreAccount = (params) => {
  return axios.post(`${base}/api/WeChatMember/GetStoreAccount`, params)
}

// 获取门店
export const GetStore = (params) => {
  return axios.post(`${base}/api/WeChatMember/GetStore`, params)
}
// 获取人数统计
export const GetMemberCountList = (params) => {
  return axios.get(`${base}/api/WebMember/GetMemberCountList`, {
    params: params,
  })
}

// 课程解锁规则管理
export const GetUnlockRuleList = (params) => {
  return axios.post(`${base}/api/WebCurriculumUnlock/GetList`, params)
}
export const GetUnlockRule = (params) => {
  return axios.get(`${base}/api/WebCurriculumUnlock/Get`, {
    params: params,
  })
}
export const AddUnlockRule = (params) => {
  return axios.post(`${base}/api/WebCurriculumUnlock/Add`, params)
}
export const UpdateUnlockRule = (params) => {
  return axios.put(`${base}/api/WebCurriculumUnlock/Update`, params)
}
export const DeleteUnlockRule = (params) => {
  return axios.delete(`${base}/api/WebCurriculumUnlock/Delete`, {
    params: params,
  })
}
export const GetCurriculumSelectList = (params) => {
  return axios.get(`${base}/api/WebCurriculumUnlock/GetCurriculumSelectList`, {
    params: params,
  })
}

// Banner管理
export const BannerGetList = (params) => {
  return axios.post(`${base}/api/WebBanner/GetList`, params)
}
export const BannerGet = (params) => {
  return axios.get(`${base}/api/WebBanner/Get`, {
    params: params,
  })
}
export const BannerAdd = (params) => {
  return axios.post(`${base}/api/WebBanner/Add`, params)
}
export const BannerUpdate = (params) => {
  return axios.put(`${base}/api/WebBanner/Update`, params)
}
export const BannerDelete = (params) => {
  return axios.delete(`${base}/api/WebBanner/Delete`, {
    params: params,
  })
}

// 证书发放规则管理
export const CertificateRuleGetList = (params) => {
  return axios.post(`${base}/api/WebCertificateRule/GetList`, params)
}
export const CertificateRuleGet = (params) => {
  return axios.get(`${base}/api/WebCertificateRule/Get`, {
    params: params,
  })
}
export const CertificateRuleAdd = (params) => {
  return axios.post(`${base}/api/WebCertificateRule/Add`, params)
}
export const CertificateRuleUpdate = (params) => {
  return axios.put(`${base}/api/WebCertificateRule/Update`, params)
}
export const CertificateRuleDelete = (params) => {
  return axios.delete(`${base}/api/WebCertificateRule/Delete`, {
    params: params,
  })
}
// 立即检查并补发(对该规则跑全量用户发证 + 回刷历史邮寄状态)
// 用户量较大时可能耗时数十秒至几分钟，单独调高超时时间
export const CertificateRuleBatchIssue = (params) => {
  return axios.post(`${base}/api/WebCertificateRule/BatchIssueByRule`, null, {
    params: params,
    timeout: 600000, // 10 分钟
  })
}
// 查看满足规则的人员列表(dry-run 不发证，分页)
// 同样可能耗时，调高超时时间
export const CertificateRuleEligibleMembers = (params) => {
  return axios.get(`${base}/api/WebCertificateRule/GetEligibleMembers`, {
    params: params,
    timeout: 600000, // 10 分钟
  })
}
// 单人补发：对指定用户在指定规则下发证
export const CertificateRuleIssueByMember = (params) => {
  return axios.post(`${base}/api/WebCertificateRule/IssueByRuleForMember`, null, {
    params: params,
  })
}

// 证书发放记录管理
export const CertificateRecordGetList = (params) => {
  return axios.post(`${base}/api/WebCertificateRecord/GetList`, params)
}
export const CertificateRecordExport = (params) => {
  return axios.post(`${base}/api/WebCertificateRecord/Export`, params)
}

// 证书物流管理
export const CertificateDeliveryGetList = (params) => {
  return axios.post(`${base}/api/WebCertificateDelivery/GetList`, params)
}
export const CertificateDeliveryUpdate = (params) => {
  return axios.put(`${base}/api/WebCertificateDelivery/Update`, params)
}
export const CertificateDeliveryExport = (params) => {
  return axios.post(`${base}/api/WebCertificateDelivery/Export`, params)
}

// 证书申请审核管理(RuleType=2)
export const CertificateApplyGetList = (params) => {
  return axios.post(`${base}/api/WebCertificateApply/GetList`, params)
}
export const CertificateApplyGet = (params) => {
  return axios.get(`${base}/api/WebCertificateApply/Get`, {
    params: params,
  })
}
export const CertificateApplyAudit = (params) => {
  return axios.post(`${base}/api/WebCertificateApply/Audit`, params)
}

// 课程投票管理
export const CurriculumVoteGetList = (params) => {
  return axios.post(`${base}/api/WebCurriculumVote/GetVoteList`, params)
}
export const CurriculumVoteGetStats = (params) => {
  return axios.get(`${base}/api/WebCurriculumVote/GetVoteStats`, {
    params: params,
  })
}
export const CurriculumVoteExport = (params) => {
  return axios.post(`${base}/api/WebCurriculumVote/ExportVoteList`, params)
}

// 平台指引管理
export const PlatformGuideGetList = (params) => {
  return axios.get(`${base}/api/PlatformGuide/GetPageList`, {
    params: params,
  })
}
export const PlatformGuideGet = (params) => {
  return axios.get(`${base}/api/PlatformGuide/GetById`, {
    params: params,
  })
}
export const PlatformGuideAdd = (params) => {
  return axios.post(`${base}/api/PlatformGuide/Add`, params)
}
export const PlatformGuideUpdate = (params) => {
  return axios.put(`${base}/api/PlatformGuide/Update`, params)
}
export const PlatformGuideDelete = (params) => {
  return axios.delete(`${base}/api/PlatformGuide/Delete`, {
    params: params,
  })
}
